var _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 11,
    height: 16,
    rx: 2,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16797 16V14.1309C3.16797 12.8008 3.60156 12.3789 4.44531 11.7461L5.16016 11.207C5.6582 10.8262 5.75781 10.668 5.75781 10.2168V9.12695C5.75781 8.88086 5.68164 8.79883 5.49414 8.79883C5.30078 8.79883 5.21289 8.89258 5.21289 9.26758V10.4805H3.18555V9.32031C3.18555 8.04883 4.01172 7.35156 5.53516 7.35156C7.02344 7.35156 7.80273 8.01367 7.80273 9.05664V10.4219C7.80273 11.4062 7.41602 11.8047 6.69531 12.373L5.98047 12.9297C5.48242 13.3281 5.39453 13.4043 5.35352 13.7734V14.2188H7.80273V16H3.16797Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 4,
    width: 11,
    height: 16,
    rx: 2,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16.1875C15.7363 16.1875 15.1211 15.4785 15.1211 13.668V9.86523C15.1211 8.05469 15.7363 7.35742 17.5 7.35742C19.252 7.35742 19.8789 8.05469 19.8789 9.86523V13.668C19.8789 15.4785 19.252 16.1875 17.5 16.1875ZM17.5 14.7461C17.7344 14.7461 17.7812 14.6055 17.7812 14.002V9.49609C17.7812 8.92773 17.7402 8.79883 17.5 8.79883C17.2539 8.79883 17.2129 8.92773 17.2129 9.49609V14.002C17.2129 14.6055 17.2598 14.7461 17.5 14.7461Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGames);
export default __webpack_public_path__ + "static/media/icon-games.8e4f17476dfb8255c90c3bac8e341cbb.svg";
export { ForwardRef as ReactComponent };